/* @kdd-custom — Pastilles de couleur de repli (21.08).
   Pose la classe `kdd-swatch-repli` sur une option de COULEUR dépourvue de
   pastilles natives, et reproduit ce que fait Shopify sur les vraies
   pastilles : le nom du coloris choisi s'affiche dans la légende
   (« Couleur · Marron ») et chaque rond porte son nom en infobulle.
   Sans ce script : aucune classe, donc aucun style de repli — les boutons
   texte restent en place, lisibles et cliquables. Rien n'est cassé. */
(function () {
  function estCouleur(option) {
    var input = option.querySelector('input[data-option-name]');
    if (!input) return false;
    var nom = (input.getAttribute('data-option-name') || '').toLowerCase();
    return nom.indexOf('couleur') > -1 || nom.indexOf('color') > -1;
  }

  function majLegende(option) {
    var legend = option.querySelector('legend');
    if (!legend) return;
    var coche = option.querySelector('input:checked');
    if (!coche) return;
    var val = legend.querySelector('.variant-option__swatch-value');
    if (!val) {
      val = document.createElement('span');
      val.className = 'variant-option__swatch-value';
      legend.appendChild(val);
    }
    val.textContent = coche.value;
  }

  function init() {
    document.querySelectorAll('.variant-option').forEach(function (option) {
      /* Une option qui a déjà ses pastilles natives n'est pas concernée. */
      if (option.classList.contains('variant-option--swatches')) return;
      if (option.classList.contains('kdd-swatch-repli')) return;
      if (!estCouleur(option)) return;

      /* On ne bascule QUE si la feuille de repli a une teinte pour au moins
         une valeur : sinon on laisse les boutons texte (mieux vaut un nom
         lisible qu'un rond gris). La liste vient du serveur — impossible de
         la lire dans le CSS, qui ne s'applique qu'une fois la classe posée. */
      var source = document.querySelector('[data-kdd-swatch-valeurs]');
      var connues = source ? (source.getAttribute('data-kdd-swatch-valeurs') || '').split('|') : [];
      var peint = false;
      option.querySelectorAll('.variant-option__button-label input').forEach(function (inp) {
        if (connues.indexOf(inp.value) > -1) peint = true;
      });
      if (!peint) return;

      option.classList.add('kdd-swatch-repli');
      option.querySelectorAll('.variant-option__button-label').forEach(function (lab) {
        var input = lab.querySelector('input');
        if (input && !lab.title) lab.title = input.value;
      });
      majLegende(option);
      option.addEventListener('change', function () { majLegende(option); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  /* Le sélecteur de variantes se re-rend au changement (morph) : on repose
     la classe après coup. */
  document.addEventListener('variant:update', init);
  /* 16.10 : correctif. Au changement de variante, Horizon met à jour le
     sélecteur par « morph » : il garde les mêmes nœuds mais réécrit leurs
     attributs, ce qui EFFACE la classe kdd-swatch-repli, et aucun évènement
     'variant:update' n'arrive sur document. On surveille donc directement le
     DOM (classes et enfants) et on repose la classe dès qu'elle saute.
     16.10 bis : init() est appelé DIRECTEMENT dans le rappel du MutationObserver
     (microtâche, avant le rendu) et non plus après 30 ms : sinon les rectangles
     natifs s'affichaient une fraction de seconde. */
  var attente;
  function relancer() { clearTimeout(attente); attente = setTimeout(init, 30); }
  function surveiller() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType === 1 && (t.closest('.variant-option') || t.querySelector && t.querySelector('.variant-option'))) { init(); return; }
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', surveiller); else surveiller();
})();
